<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">{{(isEdit) ? 'Edit' : 'Add'}} FAQ</h3>
            </div>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              enctype="multipart/form-data"
              class="body-content"
            >
              <v-row>
                <v-col cols="12">
                  <label class="form-control-label">
                    Question
                    <span class="red--text">*</span>
                  </label>
                  <v-text-field
                    v-model="faq.question"
                    placeholder="Enter FAQ Question"
                    :rules="[(v) => !!v || 'Question is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                    required
                    solo
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <label class="form-control-label">
                    Answer
                    <span class="red--text">*</span>
                  </label>
                  <quill-editor
                    v-model="faq.answer"
                    @input="error=[]"
                    ref="myQuillEditor"
                    :options="editorOption"
                  ></quill-editor>
                  <div v-if="error && error.length > 0" class="v-text-field__details pt-2 pl-2"><div class="v-messages theme--light error--text" role="alert"><div class="v-messages__wrapper"><div class="v-messages__message">{{ error[0] }}</div></div></div></div>
                </v-col>

                <v-col class="text-right" cols="12">
                  <v-btn
                    color="#989898"
                    class="mr-4 white--text"
                    @click="cancel"
                    >Cancel</v-btn
                  >
                  <v-btn
                    v-if="!isEdit"
                    :disabled="!valid"
                    :loading="loading"
                    color="#344452"
                    class="white--text"
                    @click="save"
                    >Save</v-btn
                  >
                  <v-btn
                    v-if="isEdit"
                    :disabled="!valid"
                    :loading="loading"
                    color="#344452"
                    class="white--text"
                    @click="update"
                    >Update</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import { faqService } from "@/services";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "AddFaq",
  components: {
    CommonSection,
    quillEditor
  },
  data() {
    return {
      loading: false,
      valid: true,
      faq: {
        question: null,
        answer: null,
      },
      editorOption: {
        theme: "snow",
      },
      error : [],
      isEdit: false
    };
  },
  created() {
    this.getFAQData();
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  methods: {
    cancel() {
      this.$router.push("/faq");
    },
    isEmpty () {
      return this.editor.getText().trim().length === 0
    },
    async update() {
      const value = this.isEmpty();
      if (this.$refs.form.validate() && !value) {
        this.loading = true;
        try {
          const faqs = await faqService.faqList();
          if(!this.faq.indexNumber){            
            this.faq.indexNumber = faqs.data.data.length + 1 ;
          }
          const response = await faqService.updateFAQ({
            id: this.$route.params.id,
            object: this.faq,
          });
          this.loading = false;
          if (response) {
            this.e1 = 2;
            this.$store.dispatch("user/setSnack", "FAQ updated successfully!");
            this.$store.dispatch("user/setType", "info");
            this.$router.push("/faq");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      } else if(value) {
        this.error.push('Answer is required!')
      }
    },
    async getFAQData() {
      if (this.$route.params.id !== 'create') { 
        this.isEdit = true;
        const faq = await faqService.getFAQ(this.$route.params.id);
        this.faq.question = faq.data.data[0].question;
        this.faq.answer = faq.data.data[0].answer;
      }
    },
    async save() {
      const value = this.isEmpty();
      if (this.$refs.form.validate() && !value) {
        this.loading = true;
        try {
          const faqs = await faqService.faqList();
          this.faq.indexNumber = faqs.data.data.length + 1 ;
          await faqService.createFAQ(this.faq);
          this.loading = false;
          this.$router.push("/faq");
          this.$store.dispatch("user/setSnack", `FAQ ${(this.isEdit) ?  'updated' : 'added'} successfully!`);
          this.$store.dispatch("user/setType", "info");
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      } else if(value) {
        this.error.push('Answer is required!')
      }
    },
  },
};
</script>

<style scoped>
.main-content .navbar-top {
  display: none !important;
}

.body-content {
  padding: 40px !important;
}
</style>